import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { PageHero } from '../layout/PageHero';
import { demoEntryNote, getSolution, type SolutionId } from '../../data/solutionCatalog';
import { demoUrlFor } from '../../data/demoCenter';
import { SolutionBody } from './SolutionBody';
type SolutionPageProps = {
  id: SolutionId;
  /** Solution-specific sections, placed after the modules. */
  children?: React.ReactNode;
};

/** A full solution page: outcome-led hero, then the shared solution structure. */
export function SolutionPage({
  id,
  children
}: SolutionPageProps) {
  const solution = getSolution(id);
  const [lead, ...body] = solution.intro;
  return <>
      <PageHero eyebrow={`${solution.pageTitle} · ${solution.offering}`} title={solution.headline} lead={lead} body={body} backLink={{
      href: '/solutions',
      label: 'All solutions'
    }} data-id="element-2669" data-mp="33ycgwmr9xi97">
        <div className="mt-8" data-id="element-2670" data-mp="o4c5wp9mhzim">
          <a href={demoUrlFor(solution.id)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border border-navy text-navy hover:bg-surface-muted font-semibold px-5 py-3 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-2671" data-mp="o3j0brmehg22">
            {solution.demoLabel}
            <ArrowUpRight size={18} aria-hidden="true" data-id="element-2672" data-mp="8bt0ihv3ghu" />
            <span className="sr-only" data-id="element-2673" data-mp="9v9a93iprjm">(opens in a new tab)</span>
          </a>
          <p className="mt-3 text-sm text-ink-muted" data-id="element-2674" data-mp="3rf4s9gt3h5jq">{demoEntryNote}</p>
        </div>
      </PageHero>
      <SolutionBody solution={solution} data-id="element-2675" data-mp="3mlsg465lqr7v">{children}</SolutionBody>
    </>;
}